
document.addEventListener('rebuy:cart.add', async (event) => {
  // console.log('Rebuy product added');

  const response = await fetch('/cart?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble');
  const sections = await response.json();

  const miniCart = document.querySelector('mini-cart');

  miniCart.renderContents({
    id: event.detail.item?.id,
    sections
  });
});
